'use client';
import React from 'react';
import { usePathname } from 'next/navigation';
import ProductCollectionList from '@repo/ui/src/components/ProductCollectionList';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import type { MeaterProductSummary } from '@src/domain/types/MeaterProductSummary';
import MeaterProductCard from './_MeaterProductCard';

interface ProductCollectionSelectorProps {
  collectionProducts: Array<MeaterProductSummary>;
  activeProductId: string;
}

const ProductCollectionSelector = ({
  collectionProducts,
  activeProductId,
}: ProductCollectionSelectorProps) => {
  const { t } = useTranslation();
  const pathname = usePathname();
  const productBasePath = pathname.split('/').slice(0, -1).join('/');

  if (collectionProducts.length <= 1) return null;

  return (
    <ProductCollectionList
      items={collectionProducts}
      activeId={activeProductId}
      itemsLabel={t('productDetailPageContent.productsAvailableText', undefined, {
        default: 'products available',
      })}
      renderItem={(item, selected) => (
        <MeaterProductCard
          item={item}
          selected={selected}
          productUrl={`${productBasePath}/${item.handle}`}
        />
      )}
    />
  );
};

export default ProductCollectionSelector;
